// extracted by mini-css-extract-plugin
module.exports = {"action":"action__2pKhe","icon":"icon__3RpCD","action-warning":"action-warning__1sGTQ"};